import React from 'react';
import ComunicadosView from '../Comunicados/ComunicadosView';
import NavigationUser from '../Layouts/Navigation/NavigationUser';

const ComunicadosUser = () => (
  <ComunicadosView
    role="inquilinos"
    NavigationComponent={NavigationUser}
    accentColor="from-indigo-500 to-blue-600"
  />
);

export default ComunicadosUser;
